export const setSelectedZones = zones => ({
  type: 'SET_SELECTED_ZONES',
  payload: zones,
});
